import axios from 'axios';
import {
  get_request,
  post_request,
  get_request_login
} from '../axiosFun';

//获取token验证码
export const login = () => {

  return get_request("/web/get_verification")
};
//登录接口
export const user_pass = (params) => {
  params = {
    row: {
      account: params.username,
      password: params.password,
      val_code: params.code,
    }
  }
  return post_request("/web/login", params)

}
// 退出接口
export const login_exit = (params) => {
  params = {
    row: {}
  }
  return post_request("/web/exit", params)
}
// 获取权限
export const login_auth = (params) => {
  params = {
    row: {}
  }
  return post_request("/web/auth", params)
}
// 免密登录
export const get_noSecretLogin = (params) => {
  params = {
      token:params
  }
  return get_request_login("/web/noSecretLogin", params)
}



// WEBPACK FOOTER //
// ./src/api/login/api.js